import { render } from "./FilterClusterMarkplus.vue?vue&type=template&id=2ba8649f"
import script from "./FilterClusterMarkplus.vue?vue&type=script&lang=js"
export * from "./FilterClusterMarkplus.vue?vue&type=script&lang=js"
script.render = render

export default script